import React, { createContext, useState, useEffect } from 'react';
import { getProkeyTaskMetrics } from 'api/prokey/prokey.axios';

import { useTheme } from '@mui/material/styles';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  InputLabel,
  TextField,
} from '@mui/material';
import { Autocomplete } from '@mui/material/index';

import { TaskMonitorStatus   } from './components/TaskMonitorStatus/TaskMonitorStatus';
import { TaskMonitorButton   } from './components/TaskMonitorButton/TaskMonitorButton';
import { SystemRestartButton } from './components/SystemRestartButton/SystemRestartButton';
import { TaskResetButton     } from './components/TaskResetButton/TaskResetButton';

const STD_REFRESH_INTERVAL = 5000;

//-----------------------------------------------------------------
export function SystemManagement() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const [ batch_names    , setBatchNames    ] = useState( [] );
  const [ selected_batch , setSelectedBatch ] = useState( null );

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      flex      : '1 1 45%' ,
      minWidth  : '25rem'   ,
      minHeight : '19rem'   ,
      height    : '100%'    ,
      padding   : '0.5rem'  ,
      borderRadius : '1rem',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    button_container: {      
      display  : 'flex'     ,
      flexWrap : 'wrap'     ,
      flex     : '1 1 auto' ,
    },
    reset_container: {      
      padding: '0.5rem',
    },
    task_list: {      
      width: '100%',
    }
  }

  const CONTAINER = {
    sx      : _styles.container,
    variant : 'primary' ,
  }
  const BUTTON_CONTAINER = {
    sx : _styles.button_container,
  }
  const RESET_CONTAINER = {
    sx : _styles.reset_container,
  }
  const TASK_LIST = {
    sx          : _styles.task_list,
    options     : batch_names.map( batch => batch.value ),
    onChange    : (event)  => setSelectedBatch( event.target.textContent ),
    renderInput : (params) => <TextField {...params} label="Task Id" />   ,
  }

  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    const prokey_metrics_interval = setInterval( async () => {
      try {
        const response = await getProkeyTaskMetrics();
        setBatchNames( response.data.names );
      } catch (error) {
        console.log( error );
      }
    }, STD_REFRESH_INTERVAL);

    return () => {
      clearInterval( prokey_metrics_interval );
    };
  }, []);


  //#endregion

  //#region [EVENTS]

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Card { ...CONTAINER } >
        <CardHeader title='System Management' />
        <CardContent>
          <Box> <TaskMonitorStatus /> </Box>
          <Box { ...BUTTON_CONTAINER } >
            <TaskMonitorButton />
            <SystemRestartButton />
            <TaskResetButton task={selected_batch} />
          </Box>
          <Box { ...RESET_CONTAINER } >
            <InputLabel htmlFor='selectName'>Reset Batch Name</InputLabel>
            <Autocomplete { ...TASK_LIST } />
          </Box>
        </CardContent>
      </Card>
    );
  };

  //#endregion

  return display();
}